import Comment from '../../../../../core/components/organism/comment';
import PlayerSection from './components/PlayerSection';
import TitleSection from './components/TitleSection';

import { Typography } from '../../../../../core/components/molecules/Typography';
import { IPALessonDto } from '../../../model/dailySchedule';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';
import { useState } from 'react';
import { cnBase } from 'tailwind-variants';
import FlashcardsLesson from '../../../../../core/components/organism/flashcards';
//Use the content on the lesson pages, maybe use a content list on the store.

function LessonPage() {
  const [tabSelected, setTabSelected] = useState<'comments' | 'flashcards'>(
    'comments'
  );

  const selectedContent = useDailyScheduleContentStore(
    (s) => s.selectedContent
  );

  if (!selectedContent) {
    return (
      <div className='flex h-full items-center justify-center'>
        <Typography>Não foi possível carregar o conteúdo.</Typography>
      </div>
    );
  }

  return (
    <>
      <PlayerSection lesson={selectedContent.content as IPALessonDto} />
      <div className='flex flex-col gap-xxl md:p-8'>
        <TitleSection lesson={selectedContent.content as IPALessonDto} />
        <div className='w-full border-b-hairline border-mono-color-medium' />
        <Tabs tabSelected={tabSelected} onSelectedTab={setTabSelected} />
        {tabSelected === 'comments' && (
          <Comment
            title='Comentários da videoaula'
            targetId={selectedContent.content.id}
            targetType='Lesson'
            titleSize='h5'
          />
        )}
        <FlashcardsLesson
          videoAulaId={selectedContent.content.id}
          selected={tabSelected === 'flashcards'}
        />
      </div>
    </>
  );
}

export default LessonPage;

const Tabs = ({
  tabSelected,
  onSelectedTab,
}: {
  tabSelected: 'comments' | 'flashcards';
  onSelectedTab: (value: 'comments' | 'flashcards') => void;
}) => {
  const classSelected =
    'bg-disciplina-matematica border-disciplina-matematica !text-card-color-default';

  const tabs: {
    label: string | React.ReactNode;
    value: 'comments' | 'flashcards';
  }[] = [
    { label: 'Comentários', value: 'comments' },
    { label: <i>Flashcards</i>, value: 'flashcards' },
  ];
  return (
    <div className='flex gap-2'>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={cnBase(
            'rounded rounded-pill border-hairline border-color-brand-primary px-4 py-1 text-mono-color-black',
            tabSelected === tab.value && classSelected
          )}
          onClick={() => onSelectedTab(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
